DialogController = App.loadClass 'core::Angular/DialogController'

class exports.FieldDetailsController extends DialogController
    constructor: (@scope, @http, @transitions, @transition$, $modalInstance, @q, @rootScope, @state) ->
        super(@scope, @transitions, $modalInstance)
        @scope.drainage_options = ['Well', 'Moderate', 'Poor']
        @scope.editing = @transition$.params().editing is "true"
        # default to current calendar year if we don't have a year
        year = @transition$.params().year ? (new Date()).getFullYear()
        @scope.title = "Field Details #{year}"

        @http.post('backend/grower/layers/management-zones/get-irrigation-methods').then (response) =>
            @scope.irrigation_options = response.data.data

            @scope.loadingFieldDetails = true
            @http.post('backend/grower/fields/get-field-details', { field_id: @transition$.params().id, year: @transition$.params().year ? null }).then (response) =>
                @scope.loadingFieldDetails = false
                if response.data.data
                    @scope.field = response.data.data.field
                    @scope.details = response.data.data.details
                    # round area to the tens place
                    @scope.field.tillable_acres = Math.round(@scope.field.tillable_acres * 10) / 10

                    # try to default the irrigation option
                    for option in @scope.irrigation_options when option.name is @scope.details.irrigation_method
                        @scope.details.irrigation_method = option

        @http.post('backend/grower/farms/list').then (response) =>
            @scope.farms = response.data.data


    save: (pretending = true) =>
        @http.post('backend/grower/fields/save-field-details', { details: @formatDetailsForSave(), field: @formatFieldForSave() }).then (response) =>
            if not pretending
                @closeWithAlert({ type: 'success', msg: 'Field details saved' }, null, 2000)
                # if we came from data view, trigger a refresh of the sidebar data
            return response

        .catch (response) =>
            return @q.reject(response) if response.status is 422

    formatDetailsForSave: () =>
        return { id: @scope.details.id, irrigation_method: @scope.details.irrigation_method?.name ? null, drainage: @scope.details.drainage ? null , field_id: @scope.details.fields_id, year: @scope.details.year }

    formatFieldForSave: () =>
        return { id: @scope.field.id, farms_id: @scope.field.farm.id, name: @scope.field.name, user_id: @scope.field.owner.id }
